"use client";

import { useUIStoreHeader } from "@/stores/uiStore";

export const useHeader = useUIStoreHeader;
